
import React from 'react'
import { Helmet } from 'react-helmet';
import { useMediaQuery } from 'react-responsive'
import { useNavigate, Link } from "react-router-dom"
import Button from '../../components/Button'
import Return from '../../components/Forum/Return'
import CommentIcon from '../../images/comment.svg'
import LikeIcon from '../../images/like.svg'

export default function Post87() {

  const tabletBreakpoint = useMediaQuery({ query: '(min-width: 768px)' })

  const navigate = useNavigate()

  React.useEffect(() => { 
    window.scrollTo(0, 0)
  }, [])


  return (

    <div className="top-margin-s">

      <Helmet>
        <title>Bom dia pessoal. Estou com diabetes gestacional. Como posso abaixar a diabetes através da alimentação?</title>
        <meta 
          name="description" 
          content="Bom dia pessoal. Estou com diabetes gestacional. Como posso abaixar a diabetes através da alimentação?"/>
      </Helmet>

      <div className={(tabletBreakpoint) ? 
        "container-simple-tablet" : "container-simple"}>
        <div className="top-margin-s bottom-margin-s">
          <Return to='/forum' />
        </div>
        <div className="bottom-margin-s">
          <p className="secondary-text bottom-margin-xs">
            Marília Dornelles &#183; 13/08/2024
          </p>
        </div>


        <p className="body content bottom-padding-s">
            Bom dia pessoal. Estou com diabetes gestacional. Como posso abaixar a diabetes através da alimentação?
        </p>


        <div className="post-stats bottom-padding-xs">
          <button onClick={()=>{navigate('/forum/87')}} className="svg-btn">
            <div className="post-useful-info">
              <div> 
               <img src={LikeIcon} alt="Button indicating if you found this useful" />
              </div>
              <p className="secondary-text">
                  4 pessoas acharam útil
              </p>
            </div>
          </button>

          <div className="post-useful-info"> 
            <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
            <p className="secondary-text">
              1 comentário
            </p>
          </div> 
        </div>
        <div className="top-padding-xs">

              <div className="comment-background comment">
                <p className="body comment-fixed">
                  Bom dia, Marília!<br/><br/>Entendo que a diabetes gestacional pode ser um desafio, mas com alguns ajustes na alimentação, é possível controlá-la melhor. Aqui vão algumas dicas para te ajudar:<br/><br/>1. **Faça refeições pequenas e frequentes**: Comer a cada 3 horas pode ajudar a manter os níveis de açúcar no sangue mais equilibrados.<br/><br/>2. **Escolha carboidratos complexos**: Prefira alimentos integrais, como arroz integral, aveia, e pão integral, que liberam açúcar mais lentamente no sangue.<br/><br/>3. **Consuma proteínas e fibras**: Elas ajudam a manter a saciedade e a controlar os níveis de açúcar. Inclua alimentos como feijão, lentilha, grão-de-bico, vegetais e carnes magras.<br/><br/>4. **Evite açúcares e carboidratos simples**: Reduza o consumo de doces, refrigerantes, pães brancos e massas refinadas, pois eles podem aumentar rapidamente os níveis de glicose no sangue.<br/><br/>5. **Beba bastante água**: Manter-se hidratada é muito importante, então tente beber pelo menos 2 litros de água por dia.<br/><br/>6. **Modere as frutas**: Algumas frutas são ricas em açúcar natural. Consuma em porções controladas e prefira frutas com baixo índice glicêmico, como maçã, pera e frutas vermelhas.<br/><br/>E claro, sempre é importante seguir as orientações do seu médico e nutricionista, pois eles podem adaptar essas dicas de acordo com o seu caso específico.<br/><br/>Qualquer dúvida ou se precisar de mais alguma coisa, estou aqui para ajudar!<br/><br/>Abraços,<br/>Florence
                </p>
              </div>

              <div className="post-stats">
                <div className="bottom-margin-s">
                  <p className="secondary-text bottom-margin-xs">
                    Florence Health &#183; 13/08/2024
                  </p>
                </div>
              </div>


          <Button type="primary bottom-margin-s" onClick={()=>{navigate('/forum/87')}}>Comentar</Button>
        </div>

        <div className="top-padding-s">
          <p className="heading4 bottom-padding-xs bottom-border">Postagens Relacionadas</p>


              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    T. Estudante &#183; 23/07/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/5-geral" reloadDocument={true}>

                  <p className="heading4 primary-color bottom-margin-xs">
                    Experiência lidando com diabetes  
                  </p>

                  <p className="body primary-color content bottom-padding-xs">
                    Quando fui diagnosticado com diabetes, já uns 8 anos atrás, meu primeiro sentimento foi de revolta. Porque eu?, eu pensava. Nem muito acima do peso eu estava. Porém com o tempo fui aceitando e aprendendo a viver com essa nova realidade. No fim, diabetes mudou minha vida e a forma como eu vivo. E apesar da minha revolta inicial, a maioria dessas mudanças foi para o bem. Pensando a respeito, resolvi escrever algumas coisas que aprendi desde meu diagnóstico e que talvez sejam úteis para outras pessoas.<br/><br/>Já vou começar pelo mais importante: a primeira coisa que aprendi foi que nenhum tratamento para diabetes funciona sozinho. Diabetes, talvez mais que qualquer outra doença crônica, precisa ser gerenciada pelo paciente, porque quase qualquer coisa que nós fazemos tem um efeito no nosso nível de glicose no sangue.<br/><br/>Para diabetes não tem uma pílula milagrosa que o médico vai receitar, nós (quem tem diabetes) precisa participar ATIVAMENTE do tratamento, tomando controle da nossa saúde, estudando e aprendendo sobre a doença. <br/><br/>Isso é muito trabalhoso, mas recompensador, porque mostra o nosso poder em controlar e influenciar (pelo menos parcialmente) a nossa saúde.<br/><br/>A melhor coisa que fiz logo no início, e recomendo para quem tem diabetes, é comprar um medidor de glicose, aprender a utilizar o aparelho, e medir a glicose todos os dias (e no início, mais de uma vez ao dia). Isso foi super importante para aprender como meu nível de glicose funciona, e como as coisas que afetam ele (diferentes comidas, diferentes rotinas de exercício físico). Depois de um ano fazendo isso, eu já tinha uma boa ideia de como meu corpo e meu nível de glicose respondiam aos vários estímulos, e não precisei mais medir com tanta frequência. <br/><br/>O segundo ponto importante é a alimentação. Não vou falar de dieta diretamente, porque imagino que seja diferente para cada pessoa, mas limitar a quantidade de comida foi uma das coisas mais importantes que fiz: me ajudou chegar no peso ideal e ter mais energia e disposição. Uma coisa posso falar com segurança: o controle de diabetes se beneficia da redução de calorias ingeridas, e fiz isso principalmente trocando outras carnes por peixe e aumentando a quantidade de vegetais no meu prato.<br/><br/>Depois de colocar a alimentação em ordem, a terceira coisa mais importante que fiz foi começar a me exercitar. O truque aqui foi encontrar uma maneira de fazer exercício ser algo que eu gostava. Para mim, o que funcionou foi começar a fazer natação, algo que eu sempre tinha vontade de fazer, mas nunca tinha começado. A diabetes foi o catalisador para isso, e hoje todas as semanas, gosto muito e me faz muito bem.<br/><br/>Espero que essa minha experiência sirva e possa dar algumas ideias para quem está começando a enfrentar essa situação agora. Com controle e esforço, é possível viver com uma qualidade de vida ainda melhor do que antes da diabetes!!
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/5')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            3 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Rita Anton &#183; 12/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/79-pressao" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Oi pessoal, sou hipertensa e hoje minha pressão diastólica não saiu do 10 ou 9 ....<br/>A sistólica fica entre 12 e 13 e a diastólica entre 9 e 10.<br/>Oque vocês acham que eu devo fazer?<br/>Já tomei o remédio da pressão as 18 horas tomo a cada 12 horas, mas tenho ansiedade e não estou nem conseguindo dormir porque a pressão não abaixa.<br/>Já tá me dando até dor de cabeça
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/79')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            4 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Francisca Duarte &#183; 22/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/145-cancer" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Oi gente<br/>Fui a minha primeira consulta com mastologista oncológico, meu tipo é triplo negativo.<br/>Vou começar o tratamento com quimioterapia, alguém com esse mesmo tipo? Como tem sido o tratamento? Obrigado.
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/145')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            3 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Andressa Barros &#183; 15/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/95-cancer" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Oi pessoal. Estou enjoada de comida. O que fazer pra não ter esse enjôo? Não estou conseguindo comer nada
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/95')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            12 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        3 comentários
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    L. Carrol &#183; 23/07/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/6-geral" reloadDocument={true}>

                  <p className="heading4 primary-color bottom-margin-xs">
                    Cuidando do colesterol alto  
                  </p>

                  <p className="body primary-color content bottom-padding-xs">
                    Tenho colesterol alto faz alguns anos, e quando fui diagnosticado pela primeira vez foi um pouco de choque, mas aprendi a lidar com doença e hoje meu colesterol está em níveis normais devido às mudanças que fiz de estilo de vida.<br/><br/>No fim, tenho certeza que o diagnóstico veio para o bem, pelo seguinte motivo: nos meus estudos aprendi que cerca de 85% das pessoas com mais de 50 anos (como é meu caso agora) tem algum bloqueio significativo em suas artérias, porém sem nenhum sintoma. Em dois terços dos casos (30% das vezes) o primeiro sintoma é um ataque do coração. Eu poderia estar nessa estatística, mas não estou, porque fui diagnosticado antes e mudei meu estilo de vida!<br/><br/>Duas dicas que acho que são importantes para quem descobriu que tem essa doença ou que está preocupado com seu colesterol:<br/><br/>1 - Saiba a diferença entre colesterol HDL (colesterol bom) e LDL (colesterol ruim), e como fazer para aumentar o colesterol bom e diminuir o ruim,.<br/><br/>2 - Tem 3 coisas que temos controle, e que afetam nosso colesterol e nossa saúde: nosso peso, o que comemos e nossa prática de exercícios físicos. Essas coisas estão no nosso controle e são nossa responsabilidade.<br/><br/>Esses pontos foram os que fizeram a diferença na minha saúde, e talvez possam fazer também na sua!<br/>
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/6')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            2 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        Nenhum comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>


        </div>

      </div>
    </div>
  )
}
